// const getViewComponent = process.env.NODE_ENV === 'production' ? (path) => (resolve) => require(['@/views' + path + '.vue'], resolve) : (path) => require('@/views' + path + '.vue')

const getViewComponent = (path) => (resolve) => require(['@/views' + path + '.vue'], resolve)

export default [{
		path: '/',
		component: getViewComponent('/common/index'),
		children: [
			// {path:"/",redirect:"/visit/patientDetail"},
			{
			  path: '/set/appIndex',
			  component: getViewComponent('/set/appIndex'),
			  meta: {
			    title: '首页内容配置'
			  }
			},
      {
        path: '/set/coupon',
        component: getViewComponent('/set/coupon'),
        meta: {
          title: '优惠券列表'
        }
      },
			{
			  path: '/money/month',
			  component: getViewComponent('/money/month'),
			  meta: {
			    title: '销售额统计-按月份'
			  }
			},
			{
			  path: '/content/salesList',
			  component: getViewComponent('/content/salesList'),
			  meta: {
			    title: '分销商品'
			  }
			},
			{
			  path: '/doctor/goodsDivide',
			  component: getViewComponent('/doctor/goodsDivide'),
			  meta: {
			    title: '产品折扣页'
			  }
			},
			{
				path: '/cnmi/activity',
				component: getViewComponent('/cnmi/activity'),
				meta: {
					title: '研究院活动'
				}
			},
			{
				path: '/cnmi/time',
				component: getViewComponent('/cnmi/time'),
				meta: {
					title: '项目进展'
				}
			},
			{
				path: '/cnmi/filelist',
				component: getViewComponent('/cnmi/filelist'),
				meta: {
					title: '栏目管理'
				}
			},
			{
				path: '/cnmi/file',
				component: getViewComponent('/cnmi/file'),
				meta: {
					title: '文章编辑'
				}
			},
			{
				path: '/visit/patient',
				component: getViewComponent('/visit/patient'),
				meta: {
					title: '患者库'
				}
			},
			{
				path: '/visit/patientDetail',
				component: getViewComponent('/visit/patientDetail'),
				meta: {
					title: '患者详情'
				}
			},
			{
				path: '/card/reply',
				component: getViewComponent('/card/reply'),
				meta: {
					title: '卡片制作'
				}
			},
			{
				path: '/card/model',
				component: getViewComponent('/card/model'),
				meta: {
					title: '模板管理'
				}
			},
			{
				path: '/card/list',
				component: getViewComponent('/card/list'),
				meta: {
					title: '卡片配置'
				}
			},
			{
				path: '/set/goods',
				component: getViewComponent('/set/goods'),
				meta: {
					title: '产品管理'
				}
			},
			{
				path: '/set/app',
				component: getViewComponent('/set/app'),
				meta: {
					title: '首页模块配置'
				}
			},
			{
				path: '/salesman/mdata',
				component: getViewComponent('/salesman/mdata'),
				meta: {
					title: '文档管理'
				}
			},
			{
				path: '/salesman/data',
				component: getViewComponent('/salesman/data'),
				meta: {
					title: '资料库'
				}
			},
			{
				path: '/content/record',
				component: getViewComponent('/content/record'),
				meta: {
					title: '跨渠道商品设置'
				}
			},
			{
				path: '/user/team',
				component: getViewComponent('/user/team'),
				meta: {
					title: '组织架构管理'
				}
			},
			{
				path: '/department/user',
				component: getViewComponent('/department/user'),
				meta: {
					title: '科室管理'
				}
			},
			{
				path: '/department/list',
				component: getViewComponent('/department/list'),
				meta: {
					title: '科室搭建'
				}
			},
			{
				path: '/set/content',
				component: getViewComponent('/set/content'),
				meta: {
					title: '反馈内容配置'
				}
			},
			/* 饮食配餐管理*/
			{
				path: '/illness/list',
				component: getViewComponent('/illness/list'),
				meta: {
					title: '饮食配餐管理'
				}
			},
			{
				path: '/illness/add',
				component: getViewComponent('/illness/add'),
				meta: {
					title: '配餐编辑'
				}
			},
			/* 营养品*/
			{
				path: '/nutriment/list',
				component: getViewComponent('/nutriment/list'),
				meta: {
					title: '营养品管理'
				}
			},
			{
				path: '/nutriment/add',
				component: getViewComponent('/nutriment/add'),
				meta: {
					title: '营养品编辑'
				}
			},
			{
				path: '/nutriment/type',
				component: getViewComponent('/nutriment/type'),
				meta: {
					title: '营养品分类管理'
				}
			},
			/* 运动*/
			{
				path: '/sport/list',
				component: getViewComponent('/sport/list'),
				meta: {
					title: '运动管理'
				}
			},
			{
				path: '/sport/add',
				component: getViewComponent('/sport/add'),
				meta: {
					title: '运动编辑'
				}
			},
			{
				path: '/sport/type',
				component: getViewComponent('/sport/type'),
				meta: {
					title: '运动分类管理'
				}
			},
			/* 食品*/
			{
				path: '/food/list',
				component: getViewComponent('/food/list'),
				meta: {
					title: '食物管理'
				}
			},
			{
				path: '/food/add',
				component: getViewComponent('/food/add'),
				meta: {
					title: '食物编辑'
				}
			},
			{
				path: '/food/type',
				component: getViewComponent('/food/type'),
				meta: {
					title: '食物分类管理'
				}
			},

      {
        path: '/canal',
        component: getViewComponent('/canal'),
        meta: {
          title: '渠道建设'
        }
      },
      {
        path: '/comment/list',
        component: getViewComponent('/comment/list'),
        meta: {
          title: '评论管理'
        }
      },
      {
        path: '/set/set',
        component: getViewComponent('/set/set'),
        meta: {
          title: '基础设置'
        }
      },
      {
        path: '/money/account',
        component: getViewComponent('/money/account'),
        meta: {
          title: '待人工分账'
        }
      },
      {
        path: '/money/refundRecords',
        component: getViewComponent('/money/refundRecords'),
        meta: {
          title: '退款记录'
        }
      },
      {
        path: '/money/transferRecords',
        component: getViewComponent('/money/transferRecords'),
        meta: {
          title: '转账记录'
        }
      },
      {
        path: '/cash',
        component: getViewComponent('/cash'),
        meta: {
          title: '提现管理'
        }
      },
      {
        path: '/patient/list',
        component: getViewComponent('/patient/list'),
        meta: {
          title: '患者库'
        }
      },
      {
        path: '/patient/detail',
        component: getViewComponent('/patient/detail'),
        meta: {
          title: '患者信息'
        }
      },

      /* 基础设置 */
      {
        path: '/web/galleryList',
        component: getViewComponent('/web/galleryList'),
        meta: {
          title: '轮播图列表'
        }
      }, //预览轮播图
      /* 注册管理 */
      {
        path: '/user/userlist',
        component: getViewComponent('/user/userlist'),
        meta: {
          title: '注册用户'
        }
      }, //预览注册用户

      /* 信息统计 */
      {
        path: '/order/list',
        component: getViewComponent('/order/list'),
        meta: {
          title: '订单记录'
        }
      }, //预览订单记录
      {
        path: '/order/income',
        component: getViewComponent('/order/income'),
        meta: {
          title: '订单受益表'
        }
      },
      {
        path: '/doctor/list',
        component: getViewComponent('/doctor/list'),
        meta: {
          title: '分销员'
        }
      },
      {
        path: '/doctor/more',
        component: getViewComponent('/doctor/more'),
        meta: {
          title: '更多信息'
        }
      },

      /* 商品*/
      {
        path: '/content/list',
        component: getViewComponent('/content/list'),
        meta: {
          title: '商品列表'
        }
      },
      {
        path: '/content/add',
        component: getViewComponent('/content/add'),
        meta: {
          title: '商品编辑'
        }
      },
      {
        path: '/content/type',
        component: getViewComponent('/content/type'),
        meta: {
          title: '商品分类管理'
        }
      },
      {
        path: '/content/mtype',
        component: getViewComponent('/content/mtype'),
        meta: {
          title: '商品二级分类'
        }
      },
      {
        path: '/information/activity',
        component: getViewComponent('/information/activity'),
        meta: {
          title: '促销活动'
        }
      },

      /* 在线评估的问题 */
      {
        path: '/survey/questionList',
        component: getViewComponent('/survey/questionList'),
        meta: {
          title: '在线评估问题集合 - 国华生命科技'
        }
      },
      {
        path: '/survey/addQuestion',
        component: getViewComponent('/survey/addQuestion'),
        meta: {
          title: '在线评估问题设置 - 国华生命科技'
        }
      },
      {
        path: '/survey/resultList',
        component: getViewComponent('/survey/resultList'),
        meta: {
          title: '在线评估得分区间 - 国华生命科技'
        }
      },
      {
        path: '/survey/addResult',
        component: getViewComponent('/survey/addResult'),
        meta: {
          title: '在线评估得分结果设置 - 国华生命科技'
        }
      },
      {
        path: '/survey/replyRecordList',
        component: getViewComponent('/survey/replyRecordList'),
        meta: {
          title: '评估记录 - 国华生命科技'
        }
      },
      {
        path: '/survey/replyDetails',
        component: getViewComponent('/survey/replyDetails'),
        meta: {
          title: '评估详情 - 国华生命科技'
        }
      },

      /* 在线评估的问题 */
      {
        path: '/salesman/list',
        component: getViewComponent('/salesman/list'),
        meta: {
          title: '业务员管理 - 国华生命科技'
        }
      },

      {
        path: '/money/salesmanDivide',
        component: getViewComponent('/money/salesmanDivide'),
        meta: {
          title: '业务员人工分账 - 国华生命科技'
        }
      },

      {
        path: '/money/settleRecord',
        component: getViewComponent('/money/settleRecord'),
        meta: {
          title: '线下结算单 - 国华生命科技'
        }
      },

      {
        path: '/doctor/patientList',
        component: getViewComponent('/doctor/patientList'),
        meta: {
          title: '医生绑定的患者'
        }
      },

      {
        path: '/agent/list',
        component: getViewComponent('/agent/list'),
        meta: {
          title: '代理管理'
        }
      },
      {
        path: '/agent/teamManage',
        component: getViewComponent('/agent/teamManage'),
        meta: {
          title: '团队管理'
        }
      },
      {
        path: '/agent/orderStatistics',
        component: getViewComponent('/agent/orderStatistics'),
        meta: {
          title: '订单统计'
        }
      },

      {
        path: '/business/list',
        component: getViewComponent('/business/list'),
        meta: {
          title: '业务资源库'
        }
      },
      {
        path: '/business/add',
        component: getViewComponent('/business/add'),
        meta: {
          title: '添加资源'
        }
      },
      {
        path: '/doctor/collectInfo',
        component: getViewComponent('/doctor/collectInfo'),
        meta: {
          title: '患者信息收集'
        }
      },
      {
        path: '/order/divideSupply',
        component: getViewComponent('/order/divideSupply'),
        meta: {
          title: '人工分账'
        }
      },
      {
        path: '/order/personalList',
        component: getViewComponent('/order/personalList'),
        meta: {
          title: '订单管理'
        }
      },
      {
        path: '/doctor/illness',
        component: getViewComponent('/doctor/illness'),
        meta: {
          title: '疾病诊断的选项设置'
        }
      },
      {
        path: '/cnmi/infor_edit',
        component: getViewComponent('/cnmi/infor_edit'),
        meta: {
          title: '资讯编辑'
        }
      },
      {
        path: '/content/specfication',
        component: getViewComponent('/content/specfication'),
        meta: {
          title: '商品规格'
        }
      }
    ],

    meta: {
      title: '国华生命科技'
    }
  },
  {
    path: '/article',
    component: getViewComponent('/article'),
    meta: {
      title: '文章'
    }
  },

  {
    path: '/login',
    component: getViewComponent('/common/login'),
    meta: {
      title: '登录-国华生命科技'
    }
  }
]



// WEBPACK FOOTER //
// ./src/routes/routes.js